/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SensorOrderBy {
    DEVICE_NAME = 'device_name',
    _DEVICE_NAME = '-device_name',
    TYPE = 'type',
    _TYPE = '-type',
    CREATED_DATETIME = 'created_datetime',
    _CREATED_DATETIME = '-created_datetime',
    UPDATED_DATETIME = 'updated_datetime',
    _UPDATED_DATETIME = '-updated_datetime',
}
